import { Assumption } from '@portal/pkg-api/gen/navigator'
import { AssumptionApi } from '@portal/pkg-api/navigator'
import { useQuery } from '@tanstack/react-query'
import { collectionSortNumericFn } from '@migrate/utils/sort'
import {
  IAssumptionState,
  ICategory,
} from '@migrate/components/navigator/stores/AssumptionPickerStore'

const prefix = 'admin.categories'

export const CategoryQueries = {
  categoriesFilterable: (options: CategoriesFilterableOptions) => ({
    queryKey: [`${prefix}.categoriesFilterable`, options],
    queryFn: categoriesFilterableQueryFn(options),
  }),
}

const categoriesFilterableQueryFn =
  ({
    onlyFilterable,
    excludePseudo,
    entityTypeId,
    includedAssumptionTypes,
    excludedAssumptionTypes,
  }: CategoriesFilterableOptions) =>
  async (): Promise<ICategory[]> => {
    const as = entityTypeId
      ? await AssumptionApi.getAssumptions(entityTypeId)
      : await AssumptionApi.getAllAssumptions()

    const cats = await AssumptionApi.getCategories()

    return cats.data
      .map((category) => {
        const asStates: IAssumptionState[] = as.data
          ? as.data
              .filter((a) => a.categoryId === category.id)
              .filter((ps) => {
                return excludePseudo ? !ps.pseudo : true
              })
              .filter((of) => {
                return onlyFilterable ? of.filterable : true
              })
              .filter((at) => {
                return includedAssumptionTypes && includedAssumptionTypes.length
                  ? includedAssumptionTypes.includes(at.type)
                  : true
              })
              .filter((at) => {
                return excludedAssumptionTypes && excludedAssumptionTypes.length
                  ? !excludedAssumptionTypes.includes(at.type)
                  : true
              })
              .map((fa: Assumption) => {
                return {
                  assumption: fa,
                  checked: false,
                  filtered: false,
                  disabled: false,
                }
              })
          : []

        return {
          id: category.id,
          categoryTypeCode: category.categoryTypeCode,
          name: category.name,
          sortIndex: category.sortIndex,
          category: category!,
          assumptions: asStates,
          allSelected: false,
          filtered: false,
          open: true,
        }
      })
      .filter((c) => c.assumptions.length > 0)
      .sort(collectionSortNumericFn('category.sortIndex'))
  }

type CategoriesFilterableOptions = {
  onlyFilterable: boolean
  excludePseudo: boolean
  entityTypeId?: number
  includedAssumptionTypes?: string[]
  excludedAssumptionTypes?: string[]
}

export function useCategoriesByEntityTypeMaybeForFilterable(
  onlyFilterable: boolean,
  excludePseudo: boolean,
  entityTypeId?: number,
  includedAssumptionTypes?: string[],
  excludedAssumptionTypes?: string[],
) {
  return useQuery({
    ...CategoryQueries.categoriesFilterable({
      onlyFilterable,
      excludePseudo,
      entityTypeId,
      includedAssumptionTypes,
      excludedAssumptionTypes,
    }),
    staleTime: 0,
  })
}
